import { createSlice } from "@reduxjs/toolkit";
import { CondicaoGeralSorteioModel } from "../../../models/condicaoGeralSorteio/condicaoGeralModel";
import { GradePremiacaoModel } from "../../../models/gradePremiacao/gradePremiacaoModel";
import { BuscarSorteioModel } from "../../../models/sorteio/buscarSorteioModel";
import { SorteioModel } from "../../../models/sorteio/sorteioModel";
import { buscarResumoSorteio, buscarSorteio, listarSorteio } from "../../../services/sorteioService";
import { BuscarResumoSorteioModel } from "../../../models/sorteio/buscarResumoSorteioModel";
import { ResumoSorteioModel } from "../../../models/sorteio/resumoSorteioModel";
import { resetAll } from "../../actions/actions";
import { DetalhesSorteioModel } from "../../../models/sorteio/detalhesSorteioModel";

export interface SorteioState {
  //buscar sorteio
  loading: boolean;
  entity: SorteioModel;
  busca: BuscarSorteioModel;
  list: SorteioModel[];
  // buscar resumo sorteio
  loadingResumo: boolean;
  buscaResumo: BuscarResumoSorteioModel;
  listResumo: ResumoSorteioModel[];
  //buscar sorteio por empresas
  loadingEmpresas: boolean;
  listSorteioEmpresas: DetalhesSorteioModel[];
  //internal
  entityCG: CondicaoGeralSorteioModel;
  entityGradePremiacao: GradePremiacaoModel;
  cadastroCG: CondicaoGeralSorteioModel;
  modalDeletar: boolean;
  page: string;
}

const initialState: SorteioState = {
  //buscar sorteio
  loading: false,
  busca: {
    dataInicial: null,
    dataFinal: null,
    idEmpresas: null,
    idTipoSorteio: null,
  },
  list: [],
  //buscar resumo sorteio
  loadingResumo: false,
  buscaResumo: {
    idEmpresa: 0,
    idSorteio: 0,
  },
  listResumo: [],
  entity: {} as SorteioModel,
  //buscar sorteio por empresas
  loadingEmpresas: false,
  listSorteioEmpresas: [],
  //internal
  entityCG: {} as CondicaoGeralSorteioModel,
  entityGradePremiacao: {} as GradePremiacaoModel,
  cadastroCG: {} as CondicaoGeralSorteioModel,
  modalDeletar: false,
  page: "geral",
};

export const sorteioSlice = createSlice({
  name: "sorteio",
  initialState,
  reducers: {
    //buscar sorteio
    setBuscaSorteio: (state, action) => {
      state.busca = action.payload;
    },
    setEntitySorteio: (state, action) => {
      state.entity = action.payload;
    },
    //buscar resumo sorteio
    setBuscaResumoSorteio: (state, action) => {
      state.buscaResumo = action.payload;
    },
    //internal
    setPageSorteio: (state, action) => {
      state.page = action.payload;
    },
    fillEntityCG: (state, action) => {
      state.entityCG = action.payload;
    },
    fillEntityGradePremiacao: (state, action) => {
      state.entityGradePremiacao = action.payload;
    },
    cadastrarCg: (state, action) => {
      state.cadastroCG = action.payload;
    },
    setModalDeletarSorteio: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar
    builder.addCase(buscarSorteio.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarSorteio.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarSorteio.rejected, (state, action) => {
      state.loading = false;
    });

    //buscar resumo
    builder.addCase(buscarResumoSorteio.pending, (state) => {
      state.loadingResumo = true;
    });
    builder.addCase(buscarResumoSorteio.fulfilled, (state, action) => {
      state.listResumo = action.payload;
      state.loadingResumo = false;
    });
    builder.addCase(buscarResumoSorteio.rejected, (state, action) => {
      state.loadingResumo = false;
    });

    //buscar sorteio por empresas
    builder.addCase(listarSorteio.pending, (state) => {
      state.loadingEmpresas = true;
    });
    builder.addCase(listarSorteio.fulfilled, (state, action) => {
      state.listSorteioEmpresas = action.payload;
      state.loadingEmpresas = false;
    });
    builder.addCase(listarSorteio.rejected, (state, action) => {
      state.loadingEmpresas = false;
    });
  },
});

export const {
  //buscar sorteio
  setBuscaSorteio,
  setEntitySorteio,
  //buscar resumo sorteio
  setBuscaResumoSorteio,
  //internal
  setPageSorteio,
  fillEntityCG,
  fillEntityGradePremiacao,
  cadastrarCg,
  setModalDeletarSorteio,
} = sorteioSlice.actions;
export default sorteioSlice.reducer;
